import { render, staticRenderFns } from "./testComp.vue?vue&type=template&id=37239992&"
import script from "./testComp.vue?vue&type=script&lang=js&"
export * from "./testComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37239992')) {
      api.createRecord('37239992', component.options)
    } else {
      api.reload('37239992', component.options)
    }
    module.hot.accept("./testComp.vue?vue&type=template&id=37239992&", function () {
      api.rerender('37239992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/gehad/testComp.vue"
export default component.exports